import { put, takeLatest } from "redux-saga/effects";
import {
  addOrganizationFailure,
  addOrganizationRequest,
  addOrganizationSuccess,
  createConnectionForCurrentOrganizationFailure,
  createConnectionForCurrentOrganizationRequest,
  createConnectionForCurrentOrganizationSuccess,
  createGroupRoleConnectionForCurrentOrganizationFailure,
  createGroupRoleConnectionForCurrentOrganizationRequest,
  createGroupRoleConnectionForCurrentOrganizationSuccess,
  deleteConnectionForCurrentOrganizationFailure,
  deleteConnectionForCurrentOrganizationRequest,
  deleteConnectionForCurrentOrganizationSuccess,
  deleteDirectoryForCurrentOrganizationFailure,
  deleteDirectoryForCurrentOrganizationRequest,
  deleteDirectoryForCurrentOrganizationSuccess,
  createDirectoryForCurrentOrganizationFailure,
  createDirectoryForCurrentOrganizationRequest,
  createDirectoryForCurrentOrganizationSuccess,
  createDirectoryTokenForCurrentOrganizationFailure,
  createDirectoryTokenForCurrentOrganizationRequest,
  createDirectoryTokenForCurrentOrganizationSuccess,
  deleteDirectoryTokenForCurrentOrganizationFailure,
  deleteDirectoryTokenForCurrentOrganizationRequest,
  deleteDirectoryTokenForCurrentOrganizationSuccess,
  deleteGroupRoleConnectionForCurrentOrganizationFailure,
  deleteGroupRoleConnectionForCurrentOrganizationRequest,
  deleteGroupRoleConnectionForCurrentOrganizationSuccess,
  deleteOrganizationFailure,
  deleteOrganizationRequest,
  deleteOrganizationSuccess,
  getAllGroupRoleConnectionForCurrentOrganizationFailure,
  getAllGroupRoleConnectionForCurrentOrganizationRequest,
  getAllGroupRoleConnectionForCurrentOrganizationSuccess,
  getCurrentOrganizationFailure,
  getCurrentOrganizationRequest,
  getCurrentOrganizationSuccess,
  getOrganizationFailure,
  getOrganizationRequest,
  getOrganizationSuccess,
  updateConnectionForCurrentOrganizationFailure,
  updateConnectionForCurrentOrganizationRequest,
  updateConnectionForCurrentOrganizationSuccess,
  updateConnectionStatusForCurrentOrganizationFailure,
  updateConnectionStatusForCurrentOrganizationRequest,
  updateConnectionStatusForCurrentOrganizationSuccess,
  updateCurrentOrganizationFailure,
  updateCurrentOrganizationRequest,
  updateCurrentOrganizationSuccess,
  updateGroupRoleConnectionForCurrentOrganizationFailure,
  updateGroupRoleConnectionForCurrentOrganizationRequest,
  updateGroupRoleConnectionForCurrentOrganizationSuccess,
  updateJITPolicyForCurrentOrganizationFailure,
  updateJITPolicyForCurrentOrganizationRequest,
  updateJITPolicyForCurrentOrganizationSuccess,
  updateMFAPolicyForCurrentOrganizationFailure,
  updateMFAPolicyForCurrentOrganizationRequest,
  updateMFAPolicyForCurrentOrganizationSuccess,
  updateOrganizationFailure,
  updateOrganizationRequest,
  updateOrganizationStatusFailure,
  updateOrganizationStatusRequest,
  updateOrganizationStatusSuccess,
  updateOrganizationSuccess
} from "../features/organizations/organization";
import { httpDelete, httpGet, httpPost, httpPut } from "../../services";
import {
  getOrgUsersFailure,
  getOrgUsersRequest,
  getOrgUsersSuccess,
  updateOrgUsersFailure,
  updateOrgUsersRequest,
  updateOrgUsersSuccess,
  deleteOrgUsersRequest,
  deleteOrgUsersSuccess
} from "../features/organizations/users";

// Organization Sagas
function* fetchOrganizations() {
  try {
    const response = yield httpGet("/organization/all", {});
    if (response.ErrorCode) {
      throw new Error(response.Description || response.Message || response.ErrorMessage);
    }
    yield put(getOrganizationSuccess(response));
  } catch (error) {
    yield put(getOrganizationFailure(error.message));
  }
}

function* addOrganization(action) {
  try {
    const response = yield httpPost("/organization", {}, action.payload);
    if (response.ErrorCode) {
      throw new Error(response.Description || response.Message || response.ErrorMessage);
    }
    yield put(addOrganizationSuccess(response));
  } catch (error) {
    yield put(addOrganizationFailure(error.message));
  }
}

function* updateOrganization(action) {
  const { Id, ...data } = action.payload;
  try {
    const response = yield httpPut("/organization", { id: Id }, data);
    if (response.ErrorCode) {
      throw new Error(response.Description || response.Message || response.ErrorMessage);
    }
    yield put(updateOrganizationSuccess({ Data: response }));
  } catch (error) {
    yield put(updateOrganizationFailure(error.message));
  }
}

function* updateOrganizationStatus(action) {
  const { Id, active } = action.payload;
  try {
    const response = yield httpPut("/organization", { id: Id }, { IsActive: active });
    if (response.ErrorCode) {
      throw new Error(response.Description || response.Message || response.ErrorMessage);
    }
    yield put(updateOrganizationStatusSuccess({ Id, IsActive: response.IsActive }));
  } catch (error) {
    yield put(updateOrganizationStatusFailure(error.message));
  }
}

function* deleteOrganization(action) {
  const { Id } = action.payload;
  try {
    const response = yield httpDelete("/organization", { id: Id });
    if (response.ErrorCode) throw new Error(response.Description || response.Message || response.ErrorMessage);
    if (response.IsDeleted) yield put(deleteOrganizationSuccess(action.payload));
    // else yield put(deleteOrganizationFailure());
  } catch (error) {
    yield put(deleteOrganizationFailure(error.message));
  }
}

// Current Organization Sagas
function* fetchCurrentOrganization(action) {
  const Id = action.payload;
  try {
    const response = yield httpGet("/organization", { id: Id });
    if (response.ErrorCode) throw new Error(response.Description || response.Message || response.ErrorMessage);
    yield put(getCurrentOrganizationSuccess(response));
  } catch (error) {
    yield put(getCurrentOrganizationFailure(error.message));
  }
}

function* fetUsersOfCurrentOrganization(action) {
  const Id = action.payload.orgId;
  try {
    const response = yield httpGet("/organization/users", { id: Id, page: action.payload.page, limit: 5, email: action.payload.email || "" });
    if (response.ErrorCode) throw new Error(response.Description || response.Message || response.ErrorMessage);
    yield put(getOrgUsersSuccess(response));
  } catch (error) {
    yield put(getOrgUsersFailure(error.message));
  }
}

function* updateUserOfCurrentOrganization(action) {
  const { orgId, ...rest } = action.payload;
  try {
    const response = yield httpPut("/organization/addusers", { orgId }, rest);
    if (response.ErrorCode) throw new Error(response.Description || response.Message || response.ErrorMessage);

    // Handle specific error code for bulk user update
    if (Array.isArray(response) && response[0].ErrorCode === 8180) {
      throw new Error(response[0].Description || response[0].Message || response[0].ErrorMessage);
    }
    yield put(updateOrgUsersSuccess(response));
  } catch (error) {
    yield put(updateOrgUsersFailure(error.message));
  }
}

function* deleteUserOfCurrentOrganization(action) {
  const { orgId, userId } = action.payload;
  try {
    const response = yield httpDelete("/organization/users", { orgId, userId });
    if (response.ErrorCode) throw new Error(response.Description || response.Message || response.ErrorMessage);
    yield put(deleteOrgUsersSuccess({ userId }));
  } catch (error) {
    yield put(updateOrgUsersFailure(error.message));
  }
}

function* updateCurrentOrganization(action) {
  const { Id, ...data } = action.payload;
  try {
    const response = yield httpPut("/organization", { id: Id }, data);
    if (response.ErrorCode) {
      throw new Error(response.Description || response.Message || response.ErrorMessage);
    }
    yield put(updateCurrentOrganizationSuccess(response));
    yield put(updateOrganizationSuccess({ Data: response }));
  } catch (error) {
    yield put(updateCurrentOrganizationFailure(error.message));
  }
}

//Policies Sagas

function* updateJITPolicyofCurrentOrganization(action) {
  const { Id, Status } = action.payload;
  try {
    const response = yield httpPut("/organization", { id: Id }, { Policies: { JITPolicy: { Enabled: Status } } });
    if (response.ErrorCode) {
      throw new Error(response.Description || response.Message || response.ErrorMessage);
    }
    yield put(updateJITPolicyForCurrentOrganizationSuccess(Status));
  } catch (error) {
    yield put(updateJITPolicyForCurrentOrganizationFailure(error.message));
  }
}

function* updateMFAPolicyofCurrentOrganization(action) {
  const { Id, EnforcementMode } = action.payload;
  try {
    const response = yield httpPut("/organization", { id: Id }, { Policies: { MFAPolicy: { EnforcementMode } } });
    if (response.ErrorCode) {
      throw new Error(response.Description || response.Message || response.ErrorMessage);
    }
    yield put(updateMFAPolicyForCurrentOrganizationSuccess(EnforcementMode));
  } catch (error) {
    yield put(updateMFAPolicyForCurrentOrganizationFailure(error.message));
  }
}

// Connection Sagas
function* createConnection(action) {
  try {
    const response = yield httpPost(`/organization/connection`, { orgId: action.payload.Id }, action.payload);
    if (response.ErrorCode) throw new Error(response.Description || response.Message || response.ErrorMessage);
    yield put(createConnectionForCurrentOrganizationSuccess(response));
  } catch (error) {
    yield put(createConnectionForCurrentOrganizationFailure(error.message));
  }
}

function* updateConnection(action) {
  try {
    const { orgId, connId, ...rest } = action.payload;
    const data = {
      ...rest,
      ...(rest.IDPCertificate?.Certificate && { IDPCertificate: rest.IDPCertificate.Certificate })
    };
    const response = yield httpPut(`/organization/connection`, { orgId, connId }, data);
    if (response.ErrorCode) throw new Error(response.Description || response.Message || response.ErrorMessage);
    yield put(updateConnectionForCurrentOrganizationSuccess(response));
  } catch (error) {
    yield put(updateConnectionForCurrentOrganizationFailure(error.message));
  }
}

function* deleteConnection(action) {
  try {
    const response = yield httpDelete(`/organization/connection`, { orgId: action.payload.orgId, connId: action.payload.connId });
    if (response.ErrorCode) throw new Error(response.Description || response.Message || response.ErrorMessage);
    yield put(deleteConnectionForCurrentOrganizationSuccess(action.payload.connId));
  } catch (error) {
    yield put(deleteConnectionForCurrentOrganizationFailure(error.message));
  }
}

function* deleteDirectory(action) {
  try {
    const response = yield httpDelete(`/organization/${action.payload.orgId}/scim`, {});
    if (response.ErrorCode) throw new Error(response.Description || response.Message || response.ErrorMessage);
    if (response.IsDeleted) {
      yield put(deleteDirectoryForCurrentOrganizationSuccess());
    } else {
      throw new Error("Failed to delete directory");
    }
  } catch (error) {
    yield put(deleteDirectoryForCurrentOrganizationFailure(error.message));
  }
}

function* createDirectory(action) {
  try {
    const { orgId, ...rest } = action.payload;
    const response = yield httpPost(`/organization/${orgId}/scim`, {}, rest);
    if (response.ErrorCode) throw new Error(response.Description || response.Message || response.ErrorMessage);
    yield put(createDirectoryForCurrentOrganizationSuccess(response));
  } catch (error) {
    yield put(createDirectoryForCurrentOrganizationFailure(error.message || "Failed to create directory"));
  }
}

function* createDirectoryToken(action) {
  try {
    const { orgId, ...rest } = action.payload;
    const response = yield httpPost(`/organization/${orgId}/scim/tokens`, {}, rest);
    if (response.ErrorCode) throw new Error(response.Description || response.Message || response.ErrorMessage);
    yield put(createDirectoryTokenForCurrentOrganizationSuccess(response));
  } catch (error) {
    yield put(createDirectoryTokenForCurrentOrganizationFailure(error.message));
  }
}

function* deleteDirectoryToken(action) {
  try {
    const { orgId, tokenId } = action.payload;
    const response = yield httpDelete(`/organization/${orgId}/scim/tokens/${tokenId}`, {});
    if (response.ErrorCode) throw new Error(response.Description || response.Message || response.ErrorMessage);
    if (response.IsDeleted === true) {
      yield put(deleteDirectoryTokenForCurrentOrganizationSuccess(tokenId));
    } else {
      throw new Error("Failed to delete token");
    }
  } catch (error) {
    yield put(deleteDirectoryTokenForCurrentOrganizationFailure(error.message));
  }
}

function* updateConnectionStatus(action) {
  try {
    const { orgId, connId, ...data } = action.payload;
    const response = yield httpPut(`/organization/connection/status`, { orgId, connId }, data);
    if (response.ErrorCode) throw new Error(response.Description || response.Message || response.ErrorMessage);
    yield put(updateConnectionStatusForCurrentOrganizationSuccess({ ...response, connId }));
  } catch (error) {
    yield put(updateConnectionStatusForCurrentOrganizationFailure(error.message));
  }
}

function* getAllConnectionGroupRoles(action) {
  try {
    const response = yield httpGet(`/organization/connection/grouprole/all`, { orgId: action.payload.orgId, connId: action.payload.connId });
    if (response.ErrorCode) throw new Error(response.Description || response.Message || response.ErrorMessage);
    yield put(getAllGroupRoleConnectionForCurrentOrganizationSuccess({ groupRoles: response.Data, connId: action.payload.connId, orgId: action.payload.orgId }));
  } catch (error) {
    yield put(getAllGroupRoleConnectionForCurrentOrganizationFailure(error.message));
  }
}

function* updateGroupRole(action) {
  try {
    const { orgId, connId, groupRole } = action.payload;
    const { Id, ...rest } = groupRole;
    const response = yield httpPut(`/organization/connection/grouprole`, { orgId, connId, groupRoleId: Id }, rest);
    if (response.ErrorCode) throw new Error(response.Description || response.Message || response.ErrorMessage);
    yield put(updateGroupRoleConnectionForCurrentOrganizationSuccess({ groupRole: response, connId, orgId }));
  } catch (error) {
    yield put(updateGroupRoleConnectionForCurrentOrganizationFailure(error.message));
  }
}

function* deleteGroupRole(action) {
  try {
    const response = yield httpDelete(`/organization/connection/grouprole`, { orgId: action.payload.orgId, connId: action.payload.connId, groupRoleId: action.payload.groupRoleId });
    if (response.ErrorCode) throw new Error(response.Description || response.Message || response.ErrorMessage);
    yield put(deleteGroupRoleConnectionForCurrentOrganizationSuccess(action.payload));
  } catch (error) {
    yield put(deleteGroupRoleConnectionForCurrentOrganizationFailure(error.message));
  }
}

function* createGroupRole(action) {
  try {
    const { orgId, connId, groupRole } = action.payload;
    const response = yield httpPost(`/organization/connection/grouprole`, { orgId, connId }, groupRole);
    if (response.ErrorCode) throw new Error(response.Description || response.Message || response.ErrorMessage);
    yield put(createGroupRoleConnectionForCurrentOrganizationSuccess({ connId, orgId, groupRole: response }));
  } catch (error) {
    yield put(createGroupRoleConnectionForCurrentOrganizationFailure(error.message));
  }
}

export function* watchOrganizationSaga() {
  yield takeLatest(getOrganizationRequest.type, fetchOrganizations);
  yield takeLatest(addOrganizationRequest.type, addOrganization);
  yield takeLatest(updateOrganizationRequest.type, updateOrganization);
  yield takeLatest(updateOrganizationStatusRequest.type, updateOrganizationStatus);
  yield takeLatest(deleteOrganizationRequest.type, deleteOrganization);
}

export function* watchCurrentOrganizationUsersSaga() {
  yield takeLatest(getOrgUsersRequest.type, fetUsersOfCurrentOrganization);
  yield takeLatest(updateOrgUsersRequest.type, updateUserOfCurrentOrganization);
  yield takeLatest(deleteOrgUsersRequest.type, deleteUserOfCurrentOrganization);
}

export function* watchCurrentOrganizationSaga() {
  yield takeLatest(getCurrentOrganizationRequest.type, fetchCurrentOrganization);
  yield takeLatest(updateCurrentOrganizationRequest.type, updateCurrentOrganization);
  yield takeLatest(createConnectionForCurrentOrganizationRequest.type, createConnection);
  yield takeLatest(updateConnectionForCurrentOrganizationRequest.type, updateConnection);
  yield takeLatest(deleteConnectionForCurrentOrganizationRequest.type, deleteConnection);
  yield takeLatest(createDirectoryForCurrentOrganizationRequest.type, createDirectory);
  yield takeLatest(createDirectoryTokenForCurrentOrganizationRequest.type, createDirectoryToken);
  yield takeLatest(deleteDirectoryForCurrentOrganizationRequest.type, deleteDirectory);
  yield takeLatest(deleteDirectoryTokenForCurrentOrganizationRequest.type, deleteDirectoryToken);
  yield takeLatest(updateConnectionStatusForCurrentOrganizationRequest.type, updateConnectionStatus);
  yield takeLatest(getAllGroupRoleConnectionForCurrentOrganizationRequest.type, getAllConnectionGroupRoles);
  yield takeLatest(updateGroupRoleConnectionForCurrentOrganizationRequest.type, updateGroupRole);
  yield takeLatest(deleteGroupRoleConnectionForCurrentOrganizationRequest.type, deleteGroupRole);
  yield takeLatest(createGroupRoleConnectionForCurrentOrganizationRequest.type, createGroupRole);
  yield takeLatest(updateJITPolicyForCurrentOrganizationRequest.type, updateJITPolicyofCurrentOrganization);
  yield takeLatest(updateMFAPolicyForCurrentOrganizationRequest.type, updateMFAPolicyofCurrentOrganization);
}
